import React from 'react';
import { components } from 'react-select';

import { Icon } from '@gumtree/ui-library';

import { SelectProps } from './types';
import {
    StyledValueContainer,
    StyledText,
    StyledSelect,
    StyledIcon,
    StyledOptionContainer,
    StyledOptionLabel,
    StyledAbundanceContainer,
} from './styles';

const Select = ({
    id,
    label,
    value,
    options,
    onChange,
    isOptionDisabled,
    getCustomSingleValue,
    ...props
}: SelectProps) => {
    const CustomSingleValue = (props) => (
        <components.SingleValue {...props}>
            {getCustomSingleValue ? getCustomSingleValue(props.data.label) : props.data.label}
        </components.SingleValue>
    );

    const CustomOption = (props) => (
        <StyledOptionContainer>
            {props.isSelected && <StyledIcon type="check" />}
            <components.Option {...props} />
        </StyledOptionContainer>
    );

    const CustomFormatOptionLabel = (props) => (
        <StyledOptionLabel>
            {props.label}
            <StyledAbundanceContainer>{props.abundance}</StyledAbundanceContainer>
        </StyledOptionLabel>
    );

    const CustomDropdownIndicator = (props) => (
        <components.DropdownIndicator {...props}>
            <Icon type="spinner" />
        </components.DropdownIndicator>
    );

    return (
        <StyledValueContainer>
            {label && <StyledText>{label}</StyledText>}
            <StyledSelect
                classNamePrefix="react-select"
                instanceId={id}
                components={{
                    Option: CustomOption,
                    DropdownIndicator: CustomDropdownIndicator,
                    SingleValue: CustomSingleValue,
                }}
                formatOptionLabel={CustomFormatOptionLabel}
                value={value}
                options={options}
                onChange={onChange}
                isOptionDisabled={isOptionDisabled}
                isSearchable={false}
                {...props}
            />
        </StyledValueContainer>
    );
};

export default Select;
